import _ from "underscore";
import Backbone from "backbone";
import componentMethods from "./component-methods";

const PROGRAM_TYPE_PREFIX = "program-type:";
const PROMOTION_TYPE_PREFIX = "promotion-type:";
const TAGS = {
    PROGRAM_TYPE_PREFIX,
    PROGRAM_TYPE_GENERIC: `${PROGRAM_TYPE_PREFIX}generic`,
    PROMOTION: `${PROMOTION_TYPE_PREFIX}*`,
    PROMOTION_ONSITE: ["onsite-promotion", `${PROMOTION_TYPE_PREFIX}onsite`],
    PROMOTION_EMAIL: [
        "email-promotion",
        "type:email",
        `${PROMOTION_TYPE_PREFIX}email`,
    ],
    PROMOTION_LINK: [`${PROMOTION_TYPE_PREFIX}link`],
    PROMOTION_APP: [`${PROMOTION_TYPE_PREFIX}app`],
};
const PROMOTION_TYPE_TAGS = _.pick(
    TAGS,
    "PROMOTION_ONSITE",
    "PROMOTION_EMAIL",
    "PROMOTION_APP"
);
const PROMOTION_TYPES = {
    LINK: "LINK",
    EMAIL: "EMAIL",
    WEB: "WEB",
    APP: "APP",
};
const FLOW_STEP_TAG_PREFIX = "component-filter:type:";
const PROMOTION_TYPE_CONFIGURATIONS = {
    EMAIL: {
        type: PROMOTION_TYPES.EMAIL,
        tags: TAGS.PROMOTION_EMAIL,
        tagName: "PROMOTION_EMAIL",
        promotionTitle: "Email",
        promotionTypeName: "Email",
        promotionTypeListName: "Emails",
        flowStepTag: `${FLOW_STEP_TAG_PREFIX}email`,
    },
    WEB: {
        type: PROMOTION_TYPES.WEB,
        tags: TAGS.PROMOTION_ONSITE,
        tagName: "PROMOTION_ONSITE",
        promotionTitle: "Web",
        promotionTypeName: "On-Site Promotion",
        promotionTypeListName: "On-Site Promotions",
        flowStepTag: `${FLOW_STEP_TAG_PREFIX}onsite`,
    },
    APP: {
        type: PROMOTION_TYPES.APP,
        tags: TAGS.PROMOTION_APP,
        tagName: "PROMOTION_APP",
        promotionTitle: "In-App",
        promotionTypeName: "In-App Promotion",
        promotionTypeListName: "In-App Promotions",
        flowStepTag: `${FLOW_STEP_TAG_PREFIX}app`,
    },
};

const ATTRIBUTES_TO_SAVE = [
    "component_version",
    "description",
    "name",
    "tags",
    "variables",
    "component_name",
    "id",
    "target_campaign_id",
];

function getPromotionTypeName(type) {
    const typeConfiguration = _.findWhere(PROMOTION_TYPE_CONFIGURATIONS, {
        tagName: type,
    });
    return typeConfiguration ? typeConfiguration.type : PROMOTION_TYPES.LINK;
}

function getPromotionTypeData(data) {
    const { tags } = data;
    let type;
    _.find(PROMOTION_TYPE_TAGS, (promotionTags, promotionType) => {
        const isFound = _.find(tags, (tag) => _.contains(promotionTags, tag));
        if (isFound) {
            type = promotionType;
        }
        return isFound;
    });
    type = type || "PROMOTION_LINK";
    return {
        promotion_type: type,
        promotion_type_name: getPromotionTypeName(type),
    };
}

const ComponentModel = Backbone.Model.extend(
    {
        urlRoot: "/api/v1/components",
        initialize() {
            this.set(getPromotionTypeData(this.toJSON()));
        },
        duplicateForCampaign(campaignId, attributes) {
            attributes.variables = _.map(attributes.variables, (variable) =>
                _.omit(variable, "value")
            );
            return Backbone.ajax({
                url: `${this.url()}/duplicate`,
                type: "post",
                contentType: "application/JSON",
                data: JSON.stringify({
                    variables: attributes.variables,
                    component_name:
                        attributes.component_name || attributes.name,
                    target_campaign_id:
                        campaignId || attributes.target_campaign_id,
                }),
                success(newComponent) {
                    return new ComponentModel(newComponent);
                },
            });
        },
        ...componentMethods,
    },
    {
        TAGS,
        PROMOTION_TYPES,
        PROMOTION_TYPE_TAGS,
        PROMOTION_TYPE_CONFIGURATIONS,
    }
);

ComponentModel.create = function (attributes) {
    return new ComponentModel(attributes);
};

ComponentModel.clone = function (componentModel) {
    const newComponentAttributes = _.pick(
        componentModel.attributes,
        ATTRIBUTES_TO_SAVE
    );
    return new ComponentModel(newComponentAttributes);
};

export default ComponentModel;
